import { useEditor, EditorContent } from '@tiptap/react'
import { StarterKit } from '@tiptap/starter-kit'
import { Image } from '@/components/ui/minimal-tiptap/extensions'
import '@/components/ui/minimal-tiptap/styles/index.css'

const SupportArticleContent = ({ content }: { content: string }) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        blockquote: { HTMLAttributes: { class: 'block-node' } },
        bulletList: { HTMLAttributes: { class: 'list-node' } },
        code: { HTMLAttributes: { class: 'inline', spellcheck: 'false' } },
        codeBlock: false,
        heading: { HTMLAttributes: { class: 'heading-node' } },
        horizontalRule: false,
        link: {
          openOnClick: true,
          HTMLAttributes: { class: 'link' },
        },
        orderedList: { HTMLAttributes: { class: 'list-node' } },
        paragraph: { HTMLAttributes: { class: 'text-node' } },
      }),
      Image.configure({ allowBase64: true }),
    ],
    content,
    editable: false,
    immediatelyRender: false,
  })

  if (!editor) return null

  return (
    <EditorContent
      editor={editor}
      className='minimal-tiptap-editor cursor-unset'
    />
  )
}

export default SupportArticleContent
